import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources - Arabic only
const resources = {
  ar: {
    translation: {
      app: {
        title: "مساعد الموارد البشرية",
        copyright: "  "
      },
      auth: {
        title: "مساعد الموارد البشرية ",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        confirmPassword: "تأكيد كلمة المرور",
        signOut: "تسجيل الخروج"
      },
      user: {
        guest: "مستخدم ضيف"
      },
      nav: {
        chat: "المحادثة",
        upload: "رفع الطلبات",
        agent: "سير العمل الذكي"
      },
      chat: {
        title: "مساعد الموارد البشرية",
        welcome: "مرحباً بك في مساعد الموارد البشرية ! كيف يمكنني مساعدتك اليوم؟",
        placeholder: "اسألني عن سياسات الموارد البشرية أو طلبات الترقية أو أي أسئلة أخرى...",
        send: "إرسال",
        thinking: "جارٍ التفكير...",
        error: "حدث خطأ. يرجى المحاولة مرة أخرى."
      },
      upload: {
        title: "رفع طلبات الترقية",
        description: "رفع ملفات إكسل أو CSV تحتوي على طلبات ترقية الموظفين للمعالجة المجمعة",
        dropzone: "اسحب وأفلت الملفات هنا، أو انقر للاختيار",
        processing: "جارٍ معالجة الملف...",
        success: "تم رفع الملف بنجاح",
        error: "خطأ في رفع الملف",
        selectFile: "يرجى اختيار ملف أولاً",
        uploadFailed: "فشل رفع الملف",
        templateFailed: "فشل في تنزيل القالب. يرجى المحاولة مرة أخرى.",
        downloadTemplate: "تنزيل القالب",
        templateDescription: "تنزيل قالب إكسل للتأكد من أن بياناتك بالتنسيق الصحيح",
        downloadExcelTemplate: "تنزيل قالب إكسل",
        selectFileTitle: "اختيار ملف",
        chooseFile: "اختر ملف إكسل أو CSV...",
        fileInfo: "معلومات الملف:",
        size: "الحجم",
        unknownType: "نوع غير معروف",
        uploadFile: "رفع الملف",
        uploading: "جارٍ الرفع...",
        processingFile: "جارٍ معالجة ملفك...",
        uploadResults: "نتائج الرفع",
        applicationsProcessed: "الطلبات المعالجة",
        preview: "معاينة (أول 3 سجلات):",
        employeeName: "اسم الموظف",
        currentPosition: "المنصب الحالي",
        newPosition: "المنصب الجديد",
        performance: "الأداء",
        instructions: "التعليمات",
        instruction1: "1. تنزيل قالب إكسل باستخدام الزر أعلاه",
        instruction2: "2. ملء بيانات طلبات الترقية الخاصة بك",
        instruction3: "3. حفظ الملف بصيغة إكسل (.xlsx) أو CSV",
        instruction4: "4. رفع الملف باستخدام زر الرفع",
        instruction5: "5. سيقوم النظام بالتحقق من صحة ومعالجة طلباتك",
        supportedFormats: "التنسيقات المدعومة",
        excelFormat: "إكسل (.xlsx, .xls)",
        csvFormat: "CSV (.csv)"
      },
      agent: {
        title: "وكيل سير عمل الترقيات",
        description: "معالجة طلبات الترقية بالذكاء الاصطناعي",
        process: "معالجة الطلبات",
        status: "حالة الوكيل",
        results: "النتائج",
        startWorkflow: "بدء سير العمل",
        refreshStatus: "تحديث الحالة",
        workflowRunning: "سير العمل قيد التشغيل...",
        workflowCompleted: "تم إنجاز سير العمل بنجاح",
        workflowFailed: "فشل سير العمل",
        error: "حدث خطأ أثناء تشغيل سير العمل",
        workflowSteps: {
          readApplications: "قراءة الطلبات",
          readApplicationsDesc: "تحميل طلبات الترقية",
          aiAnalysis: "التحليل بالذكاء الاصطناعي",
          aiAnalysisDesc: "تحليل الطلبات باستخدام الذكاء الاصطناعي",
          hrNotification: "إشعار الموارد البشرية",
          hrNotificationDesc: "إشعار مدير الموارد البشرية",
          financialAnalysis: "التحليل المالي",
          financialAnalysisDesc: "حساب التأثير المالي",
          meetingScheduled: "جدولة الاجتماع",
          meetingScheduledDesc: "جدولة اجتماع الموافقة",
          finalApproval: "الموافقة النهائية",
          finalApprovalDesc: "معالجة الموافقات النهائية",
          employeeNotifications: "إشعارات الموظفين",
          employeeNotificationsDesc: "إشعار الموظفين"
        },
        summary: "ملخص النتائج",
        processedApplications: "الطلبات المعالجة",
        approvedApplications: "الطلبات المعتمدة",
        rejectedApplications: "الطلبات المرفوضة",
        pendingApplications: "الطلبات المعلقة",
        noResults: "لا توجد نتائج متاحة",
        runFirst: "يرجى تشغيل سير العمل أولاً لرؤية النتائج",
        currentStep: "الخطوة الحالية",
        completed: "مكتمل",
        pending: "معلق",
        running: "قيد التشغيل"
      },
      dialog: {
        title: "هيكل النظام",
        close: "إغلاق"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'ar', // Arabic as the only language
    fallbackLng: 'ar',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
